import React from "react";
import { bool } from "prop-types";

import PropertyManager from "./PropertyManager";
import SignInRegister from "./SignInRegister";

const AccountTools = ({ has_universal_partner_experience, signed_in }) => {
  const renderComponent = () => {
    if (has_universal_partner_experience) {
      return <PropertyManager />;
    }
    return null;
  };

  return signed_in ? renderComponent() : <SignInRegister />;
};

export default AccountTools;

AccountTools.propTypes = {
  signed_in: bool.isRequired,
  has_universal_partner_experience: bool.isRequired
};
